import React from 'react';
import { Sparkles, Leaf, Heart } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToProducts = () => {
    const element = document.getElementById('productos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-honey-50">
      {/* Background with overlay */}
      <div className="absolute inset-0 lg:left-auto lg:w-3/5 z-0">
        <img
          src="/images/hero-shampoo-acondicionador.jpg"
          alt="Shampoo y acondicionador de miel Burbujas de mami"
          className="w-full h-full object-cover object-[center_35%]"
          data-testid="hero-image"
        />
        <div className="absolute inset-0 bg-honey-50/85 lg:bg-transparent lg:bg-gradient-to-r lg:from-honey-50 lg:via-honey-50/10 lg:to-transparent"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full mb-6 border border-honey-200">
            <Sparkles className="w-4 h-4 text-honey-600" />
            <span className="text-sm font-medium text-honey-900">100% Artesanal & Natural</span>
          </div>

          {/* Main heading */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-honey-950 mb-6 leading-tight">
            Cuidado natural para tu{' '}
            <span className="text-honey-600">cabello</span>
          </h1>

          <p className="text-lg md:text-xl text-honey-900/80 mb-8 leading-relaxed">
            Productos 100% artesanales elaborados con miel de abeja orgánica. 
            Libre de sulfatos y parabenos, solo lo mejor de la naturaleza para ti.
          </p>

          {/* Features */}
          <div className="flex flex-wrap gap-4 mb-8">
            <div className="flex items-center space-x-2 bg-white/60 backdrop-blur-sm px-4 py-2 rounded-lg">
              <Leaf className="w-5 h-5 text-green-600" />
              <span className="text-sm font-medium text-honey-900">Sin químicos</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/60 backdrop-blur-sm px-4 py-2 rounded-lg">
              <Heart className="w-5 h-5 text-rose-500" />
              <span className="text-sm font-medium text-honey-900">Hecho con amor</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/60 backdrop-blur-sm px-4 py-2 rounded-lg">
              <Sparkles className="w-5 h-5 text-honey-600" />
              <span className="text-sm font-medium text-honey-900">Miel orgánica</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              size="lg"
              className="bg-honey-600 hover:bg-honey-700 text-white px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all"
              onClick={scrollToProducts}
            >
              Ver productos
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-honey-900 text-honey-900 hover:bg-honey-900 hover:text-white px-8 py-6 text-lg font-semibold transition-all"
              onClick={() => document.getElementById('sobre-nosotros')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Conocer más
            </Button>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-honey-50 to-transparent z-10"></div>
    </section>
  );
};
